import { render, staticRenderFns } from "./socialMedia.vue?vue&type=template&id=077fffb0&scoped=true&"
import script from "./socialMedia.vue?vue&type=script&lang=js&"
export * from "./socialMedia.vue?vue&type=script&lang=js&"
import style0 from "./socialMedia.vue?vue&type=style&index=0&id=077fffb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077fffb0",
  null
  
)

export default component.exports